import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { formatAppDate } from "@my-dld/utils/Utils";
import {
	getServiceName,
	GreenListStatus,
	Lookup,
	PropertyTypesItems,
	SubscriptionAll,
	SubscriptionService,
	SubscriptionServiceId
} from "@eres/greenlistapi/entities";
import { CurrencyUtil, LocaleUtil } from "@eres/core";
import { getGreenListAres } from "@eres/greenlistapi/Utils";
import { SpinnerLoader } from "../SpinnerLoader";
import { getMaxBudget } from "./views/SubscriptionDetails";


interface Props {
	subscription?: GreenListStatus;
	onUpdateSubscription: () => void;
}

interface State {
	isLoading: boolean;
	areas?: Lookup[];
	isAll?: boolean;
}

class GreenListInfo extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Props>, _prevState: State ) {
		const services = nextProps.subscription?.ServiceTypes;
		const isAll = services == null || services.length === 0 || services.find( x => x.ServiceTypeId === SubscriptionServiceId.ALL ) != null;
		return {
			isAll
		};
	}

	componentDidMount() {
		getGreenListAres().then( r => {
			this.setState( {
				isLoading: false,
				areas: r,
			} );
		} );
	}

	render() {
		const { subscription } = this.props;
		const { ServiceTypes, Mobile, ExpiryDate, Email, } = subscription ?? {};
		const { isAll, isLoading, areas } = this.state;
		if ( isLoading ) return <>
			<SpinnerLoader/>
		</>;
		return <>
			{ subscription != null && <>
				{ isAll && <ServiceInfo
					areas={ areas ?? [] } svc={ SubscriptionAll }
					key={ "all" }/> }
				{ !isAll && <>
					{ ServiceTypes && ServiceTypes.map( svc => <ServiceInfo
						areas={ areas ?? [] } svc={ svc }
						key={ svc.ServiceTypeId }/> ) }
				</> }

				<div className="flex-grid mt-2 mb-0">
					<div>
						<span>{ Strings.expiry_date } :</span><span>{ formatAppDate( ExpiryDate ) }</span>
					</div>
					<div><span>{ Strings.email } :</span><span>{ Email }</span></div>
					<div>
						<span>{ Strings.mobile_number } :</span><span>{ Mobile }</span>
					</div>
				</div>
				<button
					type="button" className="btn btn_1 btn_style mt-3"
					onClick={ this.props.onUpdateSubscription }>{ Strings.update }</button>
			</>
			}
		</>;
	}

}

function ServiceInfo( props: { svc: SubscriptionService, areas: Lookup[] } ) {
	const { svc, areas } = props;
	const { Areas: sAreas, PropertyTypes, FromValue, ToValue } = svc;
	const areaName = sAreas == null || sAreas.length === areas.length ? Strings.gl_all_areas : sAreas?.map( aId => {
		const find = areas.find( a => a.Id === aId.AreaId );
		return find ? LocaleUtil.getLocalValue( find ) : undefined;
	} ).filter( x => x != null ).join( ", " );
	const pTypes = PropertyTypes == null ? Strings.gl_any_property_type : PropertyTypes?.map( pId => {
		const find = PropertyTypesItems.find( a => a.Id === pId.PropertyTypeId );
		return find ? LocaleUtil.getLocalValue( find ) : undefined;
	} ).filter( x => x != null ).join( ", " );
	const id = svc.ServiceTypeId;
	const budgetText = FromValue == null ? undefined :
		`${ CurrencyUtil.toFormattedCurrency( FromValue, 0 ) } ${ Strings.aed } - ${ CurrencyUtil.toFormattedCurrency( ToValue ?? getMaxBudget(), 0 ) } ${ Strings.aed } `;
	return <div className="mt-4">
		<div className="section-title"><h5>{ getServiceName( svc ) }</h5></div>
		<div className="flex-grid">
			<div>
				<span>{ Strings.property_type } </span><span>{ pTypes }</span>
			</div>
			<div>
				<span>{ Strings.area } </span><span>{ areaName }</span>
			</div>
			{ id !== SubscriptionServiceId.SELL && budgetText &&
				<div>
					<span>{ Strings.gl_budget } </span><span>{ budgetText }</span>
				</div> }
		</div>
	</div>;
}

export default GreenListInfo;
